import { useCallback, useEffect, useState } from 'react';

import { EMapService } from '../../../types/map';

export const useOnboardingMapServices = () => {
  const [services, setServices] = useState<Array<EMapService>>([]);

  const listener = useCallback((event: CustomEvent<EMapService[]>) => {
    if (Array.isArray(event.detail)) {
      setServices(event.detail);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('map-services:available:v1', listener);

    return () => document.removeEventListener('map-services:available:v1', listener);
  }, [listener]);

  return {
    hasFutureService: services.includes(EMapService.FutureInfrastructure),
    hasTransportAccessibilityService: services.includes(EMapService.TransportAccessibility),
  };
};
